import { useEffect } from 'react';

import posthog from 'posthog-js';

import { useI18n } from '@app-velocity/i18n';
import { Alert, Skeleton } from '@app-velocity/ui';

import { useFlows } from '../../../../../hooks';

import { PrimaryPage } from '../../../../../layouts';

import { SelectFlowContent } from './components/SelectFlowContent';

export const SelectFlow = () => {
  const { t } = useI18n();

  const { flows, loading } = useFlows();

  useEffect(() => {
    if (!flows) return;

    posthog.capture('flows_listed', {
      count: flows.length,
    });
  }, [flows]);

  return (
    <PrimaryPage
      back=".."
      backLabel={t('prototypes:all_challenges')}
      title={t('prototypes:select_flow')}
      footer={
        flows && flows.length > 0 ? (
          <Alert
            severity="info"
            title={t('prototypes:flow_section.title')}
            message={t('prototypes:flow_section.description')}
          />
        ) : null
      }
    >
      {loading ? (
        <>
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
          <Skeleton height={30} />
        </>
      ) : (
        <SelectFlowContent flows={flows} />
      )}
    </PrimaryPage>
  );
};
